<template>
    <main>
        <h1 class="display-m">Research</h1>
        <div class="grid-cards">
            <ResearchCardComponent v-for="technology in this.technologies" 
                :key=technology.technologyTypeId 
                v-bind="technology"
                v-model:planetQueue="technology.planetQueue" 
            />
        </div>
    </main>
</template>

<style scoped>
main {
    display: flex;
    padding: 24px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    flex-shrink: 0;
}

.grid-cards {
    display: grid;
    grid-auto-rows: 1fr;
    grid-template-columns: repeat(auto-fit, minmax(352px, 1fr));
    gap: 24px;
    width: 100%;
}

@media screen and (max-width: 640px) {
    .grid-cards {
        grid-template-columns: repeat(auto-fit, minmax(311px, 1fr));
    }
}
</style>

<script>
import { sprintf } from 'sprintf-js';

import * as mercureTopicConstant from '@/constants/mercureTopicConstant';

import { userLoginDataStorage } from '@/storages/userLoginDataStorage';

import ResearchCardComponent from '@/components/ResearchCardComponent.vue';

export default {
    name: 'ResearchView',
    components: {
        ResearchCardComponent
    },
    setup() {
        const userLoginDataStorageInstance = userLoginDataStorage();

        return {
            mercureTopicConstant,
            userLoginDataStorageInstance
        }
    },
    data() {
        return {
            userId: this.userLoginDataStorageInstance.getUserId(),
            planetId: this.userLoginDataStorageInstance.getUserMainPlanetId(),
            technologies: [],
            mercureConnection: null,
        }
    },
    mounted() {
        this.getTechnologies();
        this.cretateMercureEvent();
    },
    unmounted() {
        this.closeMercureEvent();
    },
    methods: {
        getTechnologies() {
            this.$axios.getUserTechnology(this.planetId).then(response => {
                console.log("Response data:", response.data);
                console.log("Response code:", response.status);
                console.log("Response headers:", response.headers);
                this.technologies = response.data.technologyDataCollection;
            }).catch(error => {
                console.error("Error technoligies request:", error);
            });
        },
        cretateMercureEvent()
        {
            this.mercureEvent = this.$mercure.createMercureEvent(
                sprintf(mercureTopicConstant.USER_RESEARCH_VIEW_TOPIC, this.userId)
            );

            this.mercureEvent.onmessage = event => {
                const data = JSON.parse(event.data);
                
                const key = this.technologies.findIndex(obj => obj.technologyTypeId === data.technologyTypeId);
                this.technologies.splice(key, 1, data);
                this.$globalEvent.updateUserPlanetResourceView(this.planetId);
            };
        },
        closeMercureEvent()
        {
            this.mercureEvent.close();
            this.mercureEvent = null;
        }
    }
}
</script>